module.exports = __webpack_public_path__ + "img/dialog-bg.dcbdb68b.png";